<template>
  <div>
    <label for="search_scope" class="sr-only">Search scope</label>
    <select name="search_scope" id="search_scope" v-model="queryObj.index" @change="updateExistsQuery(queryObj)">
      <option v-for="opt in scope" :value="opt.value">{{ opt.label }}</option>
    </select>
  </div>
</template>

<script>
  export default {
    props:[
      "scope",
      "queryObj"
    ],
    methods: {
      updateExistsQuery: function (queryObj) {
        let $self = this;
        if (queryObj.not_exist){
          delete queryObj.not_exist;
        }
        if (queryObj.exists){
          delete queryObj.exists;
        }
        if (queryObj.index === 'chungapp.atm*'){
          queryObj.exists = 'doi';
        } else if (queryObj.index === 'chungapp.*') {
          queryObj.not_exist = 'doi';
        }
        $self.$eventBus.emit('new-search')
      }
    }
  }
</script>

<style scoped>

</style>
